export const isObject = (val: any): boolean => (typeof val === 'object' && !Array.isArray(val) && val !== null)
